export const filterType = {
  input: 0,
  select: 1,
};

export const columnType = {
  text: 0,
  image: 1
};
